module.exports = __webpack_public_path__ + "media/assets/images/blog/POST-28GENNAIO-25-OK.jpg-small-24acd8c6f57d312139b2bac4d9d51128.png";